var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { VoucherCategory, VoucherTypeIds, } from '@debbie/common/dist/economy/vouchers';
import { VoucherApplicationType, VoucherApplicationTarget, InterestFrom, } from '@debbie/common/dist/voucher-applications';
import { c } from '@debbie/cortex/dist';
import * as voucherApplications from '@debbie/cortex/dist/api/voucher-applications';
import { selectAuthToken } from '@debbie/cortex/dist/auth/selectors';
import { selectTenantId } from '@debbie/cortex/dist/selectedOwners/selectors';
import Button from '../Button';
import { X } from '../Icons';
import Messages from '../Messages';
import SentenceSelect from '../SentenceSelect';
import CreditorSelector from './CreditorSelector';
import VoucherCustomizer from './VoucherCustomizer';
import q from '@debbie/cortex/dist/query';
import { allCreditorsKey } from '@debbie/cortex/dist/creditors';
const CreateVoucherApplication = (props) => {
    var _a, _b, _c;
    const filterCategories = ((_a = props.filters) === null || _a === void 0 ? void 0 : _a.targetCategory) || ((c) => true);
    const filterTypes = ((_b = props.filters) === null || _b === void 0 ? void 0 : _b.targetType) || ((c) => true);
    const filterCreateType = ((_c = props.filters) === null || _c === void 0 ? void 0 : _c.type) || ((c) => true);
    const lang = useSelector((s) => s.lang);
    const authToken = useSelector(selectAuthToken);
    const tenantId = useSelector(selectTenantId);
    const [type, setType] = useState(VoucherApplicationType.VoucherType);
    const [target, setTarget] = useState(VoucherApplicationTarget.Both);
    const [voucherType, setVoucherType] = useState(VoucherTypeIds.PROCESSINTEREST);
    const [applyToVoucherType, setApplyToVoucherType] = useState(VoucherTypeIds.INVOICE);
    const [applyToVoucherCategory, setApplyToVoucherCategory] = useState(VoucherCategory.PRINCIPAL);
    const [voucherOptions, setVoucherOptions] = useState({ days: 30, from: InterestFrom.Date });
    const [creditor, setCreditor] = useState(null);
    const [selectingCreditor, setSelectingCreditor] = useState(false);
    const [creating, setCreating] = useState(false);
    const [error, setError] = useState(null);
    const createVoucherApplication = () => __awaiter(void 0, void 0, void 0, function* () {
        setCreating(true);
        try {
            const voucherApplication = {
                type,
                target,
                voucherType,
            };
            if (type === VoucherApplicationType.VoucherType) {
                voucherApplication.applyToVoucherType = applyToVoucherType;
            }
            else if (type === VoucherApplicationType.VoucherCategory) {
                voucherApplication.applyToVoucherCategory = applyToVoucherCategory;
            }
            voucherApplication.voucherOptions = voucherOptions;
            const application = voucherApplication;
            if (authToken != null && tenantId != null) {
                yield voucherApplications.create(tenantId, {
                    application,
                    creditorId: creditor != null ? creditor.creditorId : undefined,
                });
                yield c.voucherApplications.getVoucherApplications(tenantId);
            }
            q.invalidate([allCreditorsKey()]);
            props.onClose();
        }
        catch (e) {
            console.error(e);
            setError(lang.voucherApplications.createError);
        }
        setCreating(false);
    });
    return (React.createElement(React.Fragment, null,
        error != null && React.createElement(Messages, { type: "error", messages: [error] }),
        React.createElement(SentenceSelect, { values: {
                type: type,
                target: target,
                applyToType: applyToVoucherType,
                applyToCategory: applyToVoucherCategory,
            }, options: {
                type: Object.values(VoucherApplicationType).map((v) => ({
                    value: v,
                    label: lang.voucherApplicationTypeLabels[v],
                })),
                target: Object.values(VoucherApplicationTarget).map((v) => ({
                    value: v,
                    label: lang.voucherApplicationTargetLabels[v],
                })),
                applyToType: Object.values(VoucherTypeIds)
                    .filter(filterTypes)
                    .map((v) => ({
                    value: v,
                    label: lang.economyVoucherTypeLabels[v],
                })),
                applyToCategory: Object.values(VoucherCategory)
                    .filter(filterCategories)
                    .map((v) => ({
                    value: v,
                    label: lang.economyCategories[v],
                })),
            }, sentenceBuilder: (s) => {
                const third = s.type === VoucherApplicationType.VoucherType
                    ? { value: 'applyToType' }
                    : s.type === VoucherApplicationType.Case
                        ? ''
                        : { value: 'applyToCategory' };
                return [
                    lang.voucherApplications.textSelector1,
                    { value: 'type' },
                    ' ',
                    third,
                    lang.voucherApplications.textSelector2,
                    { value: 'target' },
                    lang.voucherApplications.textSelector3,
                ];
            }, onChange: (v) => {
                if (v.type) {
                    setType(v.type);
                }
                if (v.target) {
                    setTarget(v.target);
                }
                if (v.applyToType) {
                    setApplyToVoucherType(v.applyToType);
                }
                if (v.applyToCategory) {
                    setApplyToVoucherCategory(v.applyToCategory);
                }
            } }),
        React.createElement(VoucherCustomizer, { style: {
                marginTop: '20px',
                marginLeft: '-20px',
                marginRight: '-20px',
                marginBottom: '20px',
                width: 'calc(100% + 40px)',
            }, voucherType: voucherType, onChange: (vt, vo) => {
                setVoucherType(vt);
                setVoucherOptions(vo);
            }, filter: filterCreateType }),
        selectingCreditor ? (React.createElement(CreditorSelector, { creditor: creditor, setCreditor: (creditor) => {
                setCreditor(creditor);
                setSelectingCreditor(false);
            }, close: () => setSelectingCreditor(false) })) : creditor != null ? (React.createElement("div", null,
            React.createElement("p", { style: { marginBottom: '.5em' } }, lang.voucherApplications.forCreditor),
            React.createElement(Creditor, null,
                React.createElement("span", { style: { cursor: 'pointer' }, onClick: () => setSelectingCreditor(true) }, creditor.name),
                React.createElement(X, { style: { cursor: 'pointer' }, onClick: (e) => {
                        e.preventDefault();
                        setCreditor(null);
                    } })))) : (React.createElement(AddCreditor, { onClick: () => setSelectingCreditor(true) }, lang.voucherApplications.addCreditor)),
        React.createElement("div", { style: { textAlign: 'right' } },
            React.createElement(Button, { disabled: creating, theme: "secondary", style: { marginRight: '0.5rem' }, onClick: () => {
                    props.onClose();
                } }, lang.misc.cancel),
            React.createElement(Button, { disabled: creating, onClick: createVoucherApplication }, lang.misc.add))));
};
const AddCreditor = styled.div `
  margin-bottom: 1em;
  background: #eee;
  padding: 10px;
  border-radius: 0.5em;
  cursor: pointer;
`;
const Creditor = styled.div `
  margin-bottom: 1em;
  background: #eee;
  padding: 10px;
  border-radius: 0.5em;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export default CreateVoucherApplication;
//# sourceMappingURL=CreateVoucherApplication.js.map